module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 150.70e7cecf.png";